// Progressive phone number formatting for US numbers
export const formatPhoneNumber = (value: string): string => {
  const numbers = value.replace(/\D/g, "");

  if (numbers.length <= 3) {
    return numbers;
  }
  if (numbers.length <= 6) {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
  }
  return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(
    6,
    10,
  )}`;
};

// Decode E.164 format back to (XXX) XXX-XXXX
export const decodePhoneNumber = (e164Phone: string | undefined): string => {
  if (!e164Phone || typeof e164Phone !== "string") return "";

  const digits = e164Phone.replace(/^\+1/, "").replace(/\D/g, "");

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10,
    )}`;
  }

  return "";
};
